import classNames from "classnames";
import RtrPill from "components/design-system/rtr-pill";
import type { CanonicalSize } from "components/types/canonical-size";

type SizeSelectorProps = {
  selectedSizes: CanonicalSize[];
  setSelectedSizes: (sizes?: CanonicalSize[]) => void;
};

const SizeSelector = ({ selectedSizes, setSelectedSizes }: SizeSelectorProps) => {
  const sizeSelected = (size: CanonicalSize) => selectedSizes.includes(size);
  const canonicalSizes = ["0", "2", "4", "6", "8", "10", "12", "14", "16", "18", "20", "22"] as const;

  const onClickSize = (size: CanonicalSize) => {
    const updatedCanonicalSizes = [...selectedSizes];

    if (updatedCanonicalSizes.includes(size)) {
      const index = updatedCanonicalSizes.indexOf(size);
      updatedCanonicalSizes.splice(index, 1);
    } else {
      updatedCanonicalSizes.push(size);
    }

    setSelectedSizes(updatedCanonicalSizes);
  };

  return canonicalSizes.map(s => {
    const isSizeSelected = sizeSelected(s);
    const classes = classNames("border", "border-solid", "whitespace-nowrap", "rounded-md", "m-0", "h-full", "w-full", {
      "border-black": !isSizeSelected,
      "border-wine bg-wine100": isSizeSelected,
    });
    const dataTestId = `canonical-size-${s}-` + (isSizeSelected ? "selected" : "deselected");

    return (
      <div className="h-10 w-10 m-1" key={s}>
        <RtrPill text={s} className={classes} onClick={() => onClickSize(s)} dataTestId={dataTestId} />
      </div>
    );
  });
};

export default SizeSelector;
